export interface IAssetParameterValue {
    UploadedFilename: string;
    AssetPath: string;
    Filesize: number;
}

export class AssetParameterValue implements IAssetParameterValue {
    UploadedFilename: string;
    AssetPath: string;
    Filesize: number;

    constructor();
    constructor(obj: IAssetParameterValue);
    constructor(obj?: IAssetParameterValue) {
        this.UploadedFilename = obj && obj.UploadedFilename || undefined;
        this.AssetPath = obj && obj.AssetPath || undefined;
        this.Filesize = obj && obj.Filesize || undefined;
    }
}